import Header from 'components/VerticalLayout/Header';
import React, { useState } from 'react'
import { Tbody, Td, Th, Thead, Tr,Table } from 'react-super-responsive-table'
import { Button, Card, Col, Container, Pagination, PaginationItem, PaginationLink, Row, Spinner  } from 'reactstrap'
import bgImage from "../../../../../src/assets/images/bgImage1.jpg";
import { LuReceipt } from "react-icons/lu";
import jsPDF from 'jspdf';
import autoTable from "jspdf-autotable";
import useGetPayTransactionHistory from 'pages/Dboard/Payments/PaymentTransactions/Hooks/useGetPayTransactionHistory';
import { useQueryClient } from '@tanstack/react-query';
import useInitialData from 'context/useInitialData';

 // Style object for the sticky table headers
  const stickyHeaderStyle = {
    position: "sticky",
    top: 0,
    backgroundColor: "white",
    zIndex: 1, // Ensures header is above the scrolling content
  };

const PaymentAnalyticsPage = () => {

  // orgs data
  const {data:initData} = useInitialData();
  const orgs = initData?.organization || []

   // pagination
    const[currentPage,setCurrentPage]=useState(1);
    const pageSize = 10;

    // get the user role
    const cachedData = JSON.parse(localStorage.getItem('userData'))
    const role = cachedData.user.role;

    // search
    const[searchTerm,setSearchTerm]=useState('');
    // org filter
    const[orgFilter,setOrgFilter]=useState('')
    // type filter
    const[type,setType]=useState('');
    // products filter
    const[products,setProducts]=useState('');
    // from date
    const[fromDate,setFromDate]=useState('')
    // to date
    const[toDate,setToDate]=useState('')

    // hook for getting the pay transaction history data
    const{isPending,isSuccess,isError,error,data} = useGetPayTransactionHistory(currentPage,pageSize,searchTerm,fromDate,toDate,orgFilter);
    const results = data?.results || []
    const totalCount = data?.count || 0
    const totalPages = Math.ceil(totalCount/pageSize)

    const handleOpenReceipt = (receiptUrl) => {
        window.open(
            receiptUrl,
            "_blank",
            "noopener,noreferrer"
        );
    };

    const handleDownload = () =>{
        const doc = new jsPDF("landscape")

        doc.setFontSize(16);
        doc.text("Transaction History", 14, 15);

        const headers = [
            "SL.No",
            "Payment Id",
            "Amount",
            "Status",
            "Payment Method",
            "Date",
        ];

        const rows = results.map((item, index) => [
            index + 1,
            item.payment_intent_id,
            `$ ${item.subtotal_amount}`,
            item.status,
            item.payment_method_type,
            item.created_date
            ? new Date(item.created_date).toLocaleDateString("en-US")
            : "",
        ]);

        // 4. Table
        autoTable(doc, {
            head: [headers],
            body: rows,
            startY: 20,
            styles: {
                fontSize: 8,
                cellPadding: 2,
                overflow: "linebreak",
            },
            headStyles: {
                fillColor: [0, 173, 240],
                textColor: 255,
                fontStyle: "bold",
            },
            theme: "grid",
        });

        // 5. Download
        doc.save(`Transaction_History_${new Date().toISOString().split("T")[0]}.pdf`);
    }

  return (

    <div className='account'>
        <Header/>
        <div className='accountbg'
            style={{
                background: `url(${bgImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundAttachment:"fixed",
                paddingTop:"80px",
                minHeight:"100vh",
                overflow:"hidden",
                paddingLeft:"8px"
                }}
        >
            <Container fluid>
        <Card className='p-4'>
            <div className="pb-2 mb-0 d-flex justify-content-between align-items-center">
                <div>
                    <h5 className="fw-bold">Transaction History</h5>
                    <p className='text-muted mb-0' style={{fontSize:'0.7rem'}}>Complete payment transactions</p>
                </div>
                <div>
                    <Button className='btn w-100 py-2' style={{backgroundColor:"#00ADF0", color:"white"}}
                        onClick={handleDownload}
                    >
                        Download History
                    </Button>
                </div>
            </div>

            <Row className='mb-2'>
                <Col md={9}>
                    {/* search */}
                    <input
                        type="text" 
                        className="form-control"
                        placeholder="Payment Id"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{width:"850px"}}
                    />
                </Col>
                <Col md={3} className='d-flex justify-content-end'>
                    <div className='me-2'>
                      {/* org filter */}
                      <select
                        className="form-select"
                        value={orgFilter || ""}
                        style={{ width: '200px' }}
                        onChange={(e)=> setOrgFilter(e.target.value)}
                      >
                        <option value="">Filter by Org</option>
                        {orgs.map((org,index)=>(
                          <option key={index} value={org.org_id}>{org.name}</option>
                        ))}
                        </select>
                    </div>
                    <div className='me-2'>
                        {/* date */}
                        <input
                            type='date'
                            placeholder='From Date'
                            value={fromDate}
                            onChange={(e)=> setFromDate(e.target.value)}
                            className='form-control'
                            style={{ width: '200px' }}
                        />
                    </div>
                    <div>
                        {/* date */}
                        <input
                            type='date'
                            value={toDate}
                            onChange={(e)=>setToDate(e.target.value)}
                            className='form-control'
                            style={{ width: '200px' }}
                        />
                    </div>
                    
                </Col>
            </Row>
            <Row>
                <div style={{maxHeight:"500px",overflowY:"auto"}}>
                    <Table  className='table table-striped table-bordered'>
                        <Thead>
                            <Tr>
                                <Th style={stickyHeaderStyle}>SL.No</Th>
                                <Th style={stickyHeaderStyle}>Payment Id</Th>
                                <Th style={stickyHeaderStyle}>Amount</Th>
                                {/* <Th style={stickyHeaderStyle}>Currency</Th> */}
                                <Th style={stickyHeaderStyle}>Status</Th>
                                <Th style={stickyHeaderStyle}>Payment Method</Th>
                                <Th style={stickyHeaderStyle}>Date</Th>
                                <Th style={stickyHeaderStyle}>Receipt</Th>
                                {/* <Th>Description</Th> */}
                                {/* <Th>Product</Th> */}
                                {/* <Th style={stickyHeaderStyle}>Balance</Th> */}
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                isPending && (
                                    <Tr>
                                        <Td colSpan="5" className="text-center">
                                            <Spinner color='primary'/>
                                        </Td>
                                    </Tr>
                                )
                            }

                            {
                                isError && (
                                    <Tr>
                                        <Td colSpan="18" className="text-center text-danger">
                                            <h6>Error fecthing data: {error.message}</h6>
                                        </Td>
                                    </Tr>
                                )
                            }

                            {
                                !isPending && results.length === 0 && (
                                    <Tr>
                                        <Td colSpan="18" className="text-center">
                                            <div className='py-4'>
                                                <div className="d-flex flex-column align-items-center text-muted">
                                                <i className="bi bi-exclamation-circle fs-1 mb-2"></i>
                                                <h5 className="mb-1">No Data Found</h5>
                                                </div>
                                            </div>
                                        </Td>
                                    </Tr>
                                )
                            }

                            {
                                isSuccess && (
                                    Array.isArray(results) && results.filter((result)=>{
                                        const term = searchTerm.toLowerCase();
                                        const matchesSearch = result.payment_intent_id?.toLowerCase().includes(term) || result.user__first_name?.toLowerCase().includes(term);
                                        return matchesSearch;
                                    }).map((result,index)=>(
                                        <Tr key={index}>
                                            <Td>{index + 1}</Td>
                                            <Td>{result.payment_intent_id}</Td>
                                            <Td>$ {result.subtotal_amount}</Td>
                                            {/* <Td>{result.currency}</Td> */}
                                            <Td>{result.status}</Td>
                                            <Td>{result.payment_method_type}</Td>
                                            <Td>{result.created_date ? new Date(result.created_date).toLocaleDateString('en-US'): ''}</Td>
                                            <Td>
                                                <Button onClick={()=> handleOpenReceipt(result.receipt_url)}>
                                                    <LuReceipt />
                                                </Button>
                                            </Td>
                                        </Tr>
                                    ))
                                )
                            }
                        </Tbody>
                    </Table>

                    <div style={{display:"flex", flexDirection:"row", alignItems:"end", justifyContent:"end"}}>
                        <Pagination size='sm' className='justify-content-center'>
                        {/* first page */}
                        <PaginationItem disabled={currentPage === 1}>
                            <PaginationLink
                            first
                            onClick={()=> setCurrentPage(1)}
                            style={{
                                backgroundColor: '#f8f9fa',
                                color: '#007bff',
                                border: '1px solid #dee2e6',
                                padding: '5px 10px',
                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                            }}
                            />
                        </PaginationItem>

                        {/* previous page */}
                        <PaginationItem disabled={currentPage === 1}>
                            <PaginationLink
                                previous
                                onClick={()=>setCurrentPage(prev => prev - 1)}
                                style={{
                                backgroundColor: '#f8f9fa',
                                color: '#007bff',
                                border: '1px solid #dee2e6',
                                padding: '5px 10px',
                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                            }}
                            />
                        </PaginationItem>

                        {/* page numbers */}
                        {[...Array(totalPages)].map((_,index)=>{
                        const isActive = currentPage === index + 1;
                        return(
                            <PaginationItem key={index} active={isActive}>
                            <PaginationLink
                                onClick={()=> setCurrentPage(index + 1)}
                                style={{
                                backgroundColor: isActive ? '#007bff' : '#fff',
                                color: isActive ? '#fff' : '#007bff',
                                border: '1px solid #dee2e6',
                                padding: '5px 12px',
                                margin: '0 2px',
                                cursor: 'pointer',
                                borderRadius: '4px',
                                fontWeight: isActive ? 'bold' : 'normal',
                                }}
                            >
                                {index + 1}
                            </PaginationLink>
                            </PaginationItem>
                        )
                        })}

                        {/* next page */}
                        <PaginationItem disabled={currentPage === totalPages}>
                            <PaginationLink
                            next
                            onClick={()=> setCurrentPage(prev => prev + 1)}
                            style={{
                                backgroundColor: '#f8f9fa',
                                color: '#007bff',
                                border: '1px solid #dee2e6',
                                padding: '5px 10px',
                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                            }}
                            />
                        </PaginationItem>
        
                        {/* last page */}
                        <PaginationItem disabled={currentPage === totalPages}>
                            <PaginationLink
                                last
                                onClick={()=> setCurrentPage(totalPages)}
                                style={{
                                backgroundColor: '#f8f9fa',
                                color: '#007bff',
                                border: '1px solid #dee2e6',
                                padding: '5px 10px',
                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                                }}
                            />
                        </PaginationItem>
                        </Pagination>
                    </div>
                </div>
            </Row>
        </Card>
    </Container>
        </div>
    </div>
    
  )
}

export default PaymentAnalyticsPage
